import { useState } from "react";
import { supabase } from "../supabaseClient";

function AddSpotForm({ location, onSave, onCancel }) {
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [photoFile, setPhotoFile] = useState(null);
  const previewUrl = photoFile ? URL.createObjectURL(photoFile) : null;
  const [errorMessage, setErrorMessage] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const handleSave = async () => {

  if (isSaving) return;

  setIsSaving(true);
      
  // Require spot name
  if (!name.trim()) {
    setErrorMessage("Please enter a spot name");
    setTimeout(() => setErrorMessage(null), 2000);

    setIsSaving(false);

    return;
  }

  // Require spot type
  if (!type) {
    setErrorMessage("Please select a spot type");
    setTimeout(() => setErrorMessage(null), 2000);

    setIsSaving(false);

    return;
  }
  let photoUrl = null;

  // If a photo was selected
  if (photoFile) {
    const fileName = `${Date.now()}-${photoFile.name}`;

    const { error: uploadError } = await supabase.storage
      .from("spot-photos")
      .upload(fileName, photoFile);

    if (uploadError) {
      console.error("Upload error:", uploadError);
      alert("Photo upload failed");

      setIsSaving(false);

      return;
    }

    const { data } = supabase.storage
      .from("spot-photos")
      .getPublicUrl(fileName);

    photoUrl = data.publicUrl;
  }

 await onSave({
    name,
    type,
    lat: location.lat,
    lng: location.lng,
    photo_url: photoUrl,
  });

  setIsSaving(false);

};

  return (
    <div style={sheetStyle}>

      {errorMessage && (
  <div style={errorBanner}>
    {errorMessage}
  </div>
)}
      <div style={titleStyle}>Add New Spot</div>

      <input
        placeholder="Spot name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        style={inputStyle}
      />

      <select value={type} onChange={(e) => setType(e.target.value)} style={selectStyle}>
        <option value="" disabled>
          Select Spot Type
        </option>

        <option value="ledge">Ledge</option>
        <option value="rail">Rail</option>
        <option value="stairs">Stairs</option>
        <option value="gap">Gap</option>
        <option value="curb">Curb</option>
        <option value="park">Park</option>
        <option value="ditch">Ditch</option>
      </select>

 <label style={uploadButton}>
  Upload Photo (Optional)
  <input
    type="file"
    accept="image/*"
    onChange={(e) => setPhotoFile(e.target.files[0])}
    style={{ display: "none" }}
  />
</label>

{previewUrl && (
  <img
    src={previewUrl}
    alt="preview"
    style={previewStyle}
  />
)}

      <br /><br />

  <div style={buttonRow}>
 <button
  style={{
    ...saveButton,
    opacity: isSaving ? 0.7 : 1,
    cursor: isSaving ? "not-allowed" : "pointer",
  }}
  onClick={handleSave}
  disabled={isSaving}
>
  {isSaving ? "Saving..." : "Save Spot"}  </button>

  <button style={cancelButton} onClick={onCancel}>
    Cancel
  </button>

</div>
    </div>
  );
}

const sheetStyle = {
  position: "fixed",
  bottom: 0,
  left: 0,
  width: "100%",
  minHeight: "40vh",
  maxHeight: "75vh",
  overflowY: "auto",
  background: "#111",
  padding: "20px",
  borderTopLeftRadius: "16px",
  borderTopRightRadius: "16px",
  zIndex:9999,
};

const titleStyle = {
  fontSize: "40px",
  fontWeight: "700",
  color: "white",
  marginBottom: "18px",
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  marginBottom: "10px",
  borderRadius: "12px",
  border: "none",
  background: "#2c2c2e",
  color: "white",
  fontSize: "20px",
};

const selectStyle = {
  width: "100%",
  padding: "14px",
  marginBottom: "14px",
  borderRadius: "12px",
  border: "none",
  background: "#2c2c2e",
  color: "white",
  fontSize: "16px",
};

const uploadButton = {
  display: "block",
  width: "100%",
  padding: "14px",
  borderRadius: "12px",
  background: "#3a3a3c",
  color: "white",
  fontWeight: "600",
  textAlign: "center",
  cursor: "pointer",
  marginBottom: "18px",
};

const previewStyle = {
  width: "100%",
  borderRadius: "12px",
  marginTop: "10px",
  marginBottom: "16px",
  maxHeight: "200px",
  objectFit: "cover",
};

const buttonRow = {
  display: "flex",
  gap: "10px",
};

const saveButton = {
  flex: 1,
  padding: "14px",
  borderRadius: "12px",
  border: "none",
  background: "#297ad1",
  color: "white",
  fontSize: "16px",
  fontWeight: "700",
};

const cancelButton = {
  flex: 1,
  padding: "14px",
  borderRadius: "12px",
  border: "none",
  background: "#3a3a3c",
  color: "white",
  fontSize: "16px",
  fontWeight: "600",
};

const errorBanner = {
  background: "rgba(0,0,0,0.75)",
  color: "white",
  padding: "10px 16px",
  borderRadius: "20px",
  fontSize: "14px",
  marginBottom: "12px",
  textAlign: "center",
};

export default AddSpotForm;